import { FC } from 'react';
import { Text } from '@mofid-securities/uikit';
import { ErrorTemplateRed } from '@/components/ErrorTemplate';
import { FAQAccordion } from '@/components/FAQ';
import { useGetFundFAQs } from './FundConsultationFAQ.hooks';
import { FundConsultationFAQSkeleton } from './FundConsultationFAQ.skeleton';

export const FundConsultationFAQ: FC = () => {
  const {
    fundFAQs,
    isLoading,
    isError,
    refetchOnError,
    isFetching,
    errorMessage,
  } = useGetFundFAQs();

  if (isLoading) {
    return <FundConsultationFAQSkeleton />;
  }

  if (isError) {
    return (
      <ErrorTemplateRed
        className="min-h-[276px]"
        errorMessage={errorMessage}
        isLoading={isFetching}
        onRefetch={refetchOnError}
      />
    );
  }

  return (
    <div className="flex flex-col gap-y-3">
      <Text component="h2" size="sm" weight="demibold">
        سوالات متداول
      </Text>
      <div className="flex flex-col gap-y-2">
        {fundFAQs?.questions.map((item) => {
          return (
            <FAQAccordion key={item.id} title={item.title}>
              <div dangerouslySetInnerHTML={{ __html: item.shortAnswer }} />
            </FAQAccordion>
          );
        })}
      </div>
    </div>
  );
};
